module.exports = {"1":"Mauvais","2":"Bas","3":"Moyen","4":"Bien","5":"Excellent","1.5":"Mauvais","2.5":"Bas","3.5":"Moyen","4.5":"Excellent"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/fr-FR/star-ratings.json
// module id = 1308
// module chunks = 0